import { Box } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { ShareButton } from '@components/ShareButton';

import { useSession } from '@hooks/useSession';

import MainWrapper from '@views/Records/Common/MainWrapper';

import { useGetScanResult } from 'generated/scan.generated';
import { ShareType } from 'generated/types';
import { ScanType } from 'generated/types';

import Content from './Content';

const messages = defineMessages({
  title: {
    id: 'coughScanDrilldown.title',
    defaultMessage: 'Cough Scan',
  },
});

interface ScanResultDrilldownProps {
  id?: string;
}
/**
 * Scan result drilldown (used for cough scans only atm)
 * @returns Drilldown view of a scan result
 */
export default function ScanResultDrilldown({
  id = '',
}: ScanResultDrilldownProps) {
  const { formatMessage } = useIntl();
  const {
    state: { activeProfile },
  } = useSession();
  const patient_id = activeProfile?.vitall_patient?.patient_id ?? '';
  const title = formatMessage(messages.title);
  const { data, loading } = useGetScanResult({
    variables: {
      input: {
        record_id: id,
        patient_id,
        scan_type: ScanType.respiratory,
      },
    },
    skip: !patient_id || !id,
  });

  return (
    <MainWrapper
      backgroundIcon="logo"
      friendlyName={title}
      showBreadcrumb={false}
      showHeader
      title={title}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <ShareButton
          color="primary.main"
          resource_model_id={id}
          share_type={ShareType.SingleResource}
          vitall_patient_id={activeProfile?.vitall_patient_id ?? ''}
        />
      </Box>
      <Content data={data?.getScanResult} loading={loading} />
    </MainWrapper>
  );
}
